<template>
  <div class="min-w-[100px] p-4">
    <vue-slider
      v-model="switchVal"
      :width="width"
      :height="height"
      :max="max"
      :min="min"
      :interval="interval"
      :marks="marks"
      :hide-label="hideLabel"
      :order="order"
      :tooltip="tooltip"
      :tooltip-formatter="formatter"
      :disabled="disabled"
      drag-on-click
      class="vue-slider"
      @change="set"
    >
      <template #label="{ active, value }">
        <div
          v-if="value !== min && value !== max"
          :class="['vue-slider-mark-label', 'custom-label', { active }]"
        >
          {{ `${prefix}${value}${postfix}` }}
        </div>
        <div
          v-else-if="value === min"
          :class="['vue-slider-mark-label', 'custom-label', { active }]"
        >
          {{ `${(minPrefix || prefix) + value + (minPostfix || postfix)}` }}
        </div>
        <div
          v-else-if="value === max"
          :class="['vue-slider-mark-label', 'custom-label', { active }]"
        >
          {{ `${(maxPrefix || prefix) + value + (maxPostfix || postfix)}` }}
        </div>
      </template>
    </vue-slider>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import { computed, defineComponent } from 'vue';
export default defineComponent({
  /**
   * 最初註冊名稱與檔案名稱開頭大小寫不一致，故針對此命名（Histoire 讀檔用）
   */
  name: 'Slider',
  components: {
    VueSlider
  },
  props: {
    modelValue: {
      type: [Number, Array],
      default: 0
    },
    order: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '500px'
    },
    height: {
      type: String,
      default: '5px'
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 10
    },
    marks: {
      type: [Boolean, Array],
      default: false
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    interval: {
      type: Number,
      default: 1
    },
    tooltip: {
      type: String,
      default: 'none' // 'none' | 'always' | 'hover' | 'focus' | 'active'
    },
    prefix: {
      type: String,
      default: ''
    },
    postfix: {
      type: String,
      default: ''
    },
    minPrefix: {
      type: String,
      default: ''
    },
    maxPrefix: {
      type: String,
      default: ''
    },
    minPostfix: {
      type: String,
      default: ''
    },
    maxPostfix: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    const switchVal = computed({
      get: () => props.modelValue,
      set: (val) => {
        emit('update:modelValue', val);
      }
    });
    function set(val) {
      emit('change', val);
    }

    function formatter(val) {
      return `${props.prefix}${val}${props.postfix}`;
    }

    return {
      switchVal,
      set,
      formatter
    };
  }
});
</script>